import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useContext } from 'react';
import { Card, Table } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ProductContext } from 'context/Context';
import { getDiscountPrice } from 'helpers/utils';
import { Trans } from 'react-i18next';

const OrderSummary = ({
  shippingCost,
  subTotal,
  total,
  payableTotal,
  ...rest
}) => {
  const params = useParams();

  const {
    productsState: {
      config: { currency },
      cartItems,
      promo
    }
  } = useContext(ProductContext);

  return (
    <Card {...rest}>
      <Card.Header className="bg-light btn-reveal-trigger d-flex flex-between-center">
        <h5 className="mb-0">
          <Trans ns="commerce">Order Summary</Trans>
        </h5>
        <Link
          to={`/${params.corp}/e-commerce/shopping-cart`}
          className="btn btn-link btn-sm btn-reveal text-600"
        >
          <FontAwesomeIcon icon="pencil-alt" />
        </Link>
      </Card.Header>
      <Card.Body>
        <Table borderless className="fs--1 mb-0">
          <tbody>
            {cartItems?.map((product, index) => (
              <tr key={product.id} className="border-bottom">
                <th
                  className={classNames('ps-0', {
                    'pt-0': index === 0
                  })}
                >
                  {product.name} x {product.quantity}
                  {product.features && (
                    <div className="text-400 fw-normal fs--2">
                      {product.features.join(', ')}
                    </div>
                  )}
                </th>
                <th
                  className={classNames('pe-0 text-end', {
                    'pt-0': index === 0
                  })}
                >
                  {currency}
                  {product.totalPrice}
                </th>
              </tr>
            ))}

            <tr className="border-bottom">
              <th className="ps-0">
                <Trans ns="commerce">Subtotal</Trans>
              </th>
              <th className="pe-0 text-end">
                {currency}
                {subTotal}
              </th>
            </tr>
            <tr className="border-bottom">
              <th className="ps-0">
                <Trans ns="commerce">Shipping</Trans>
              </th>
              <th className="pe-0 text-end">
                {shippingCost && (
                  <>
                    {' '}
                    +{currency}
                    {shippingCost}
                  </>
                )}
              </th>
            </tr>
            <tr>
              <th className="ps-0 pb-0">
                <Trans ns="commerce">Total</Trans>
              </th>
              <th className="pe-0 text-end pb-0">
                {currency}
                {total}
              </th>
            </tr>
            {promo && (
              <tr className="border-bottom">
                <th className="ps-0 pb-0">
                  <Trans ns="commerce">Coupon</Trans>:
                  <span className="text-success"> {promo.code}</span> ( -
                  {promo.discount}%)
                </th>
                <th className="pe-0 text-end">
                  -{currency}
                  {getDiscountPrice(total, promo.discount)}
                </th>
              </tr>
            )}
          </tbody>
        </Table>
      </Card.Body>
      <Card.Footer className="d-flex justify-content-between bg-light">
        <div className="fw-semi-bold">
          <Trans ns="commerce">Payable Total</Trans>
        </div>
        <div className="fw-bold">
          {currency}
          {payableTotal}
        </div>
      </Card.Footer>
    </Card>
  );
};

OrderSummary.propTypes = {
  subTotal: PropTypes.number.isRequired,
  shippingCost: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  payableTotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default OrderSummary;
